import { httpDelete, httpGet, httpPatch, httpPost } from "@/src/api/http";
import type { DeleteRes, GetRes, PatchRes, PostRes, Req } from "@/src/api/types";

export function listUsers() {
    return httpGet<GetRes<"users/">>(`users/`);
}

export function updateUser(id: number, body: Req<"users/{id}/", "patch">) {
    return httpPatch<PatchRes<"users/{id}/">>(`users/${id}/`, body);
}

export function deleteUser(id: number) {
    return httpDelete<DeleteRes<"users/{id}/">>(`users/${id}/`);
}

/**
 * Validation failures here answer 400 with `error.fields` rather than the `error.field_errors`
 * used by the shared exception handler; `ApiError.fieldErrors` normalises both.
 */
export function inviteUser(body: Req<"users/invite/", "post">) {
    return httpPost<PostRes<"users/invite/">>(`users/invite/`, body);
}

export function transferOwnership(id: number, transferTo: number) {
    return httpPatch<PatchRes<"users/{id}/transfer/">>(`users/${id}/transfer/`, {
        transfer_to: transferTo,
    });
}

export function resetUserPassword(id: number) {
    return httpPatch<PatchRes<"users/{id}/reset_password/">>(`users/${id}/reset_password/`, {});
}

// --- groups ----------------------------------------------------------------------------------

export function listGroups() {
    return httpGet<GetRes<"groups/">>(`groups/`);
}

export function createGroup(name: string) {
    return httpPost<PostRes<"groups/">>(`groups/`, { name });
}

export function updateGroup(id: number, body: Req<"groups/{id}/", "patch">) {
    return httpPatch<PatchRes<"groups/{id}/">>(`groups/${id}/`, body);
}

export function deleteGroup(id: number) {
    return httpDelete<DeleteRes<"groups/{id}/">>(`groups/${id}/`);
}

// --- roles -----------------------------------------------------------------------------------

export function listRoles() {
    return httpGet<GetRes<"roles/">>(`roles/`);
}

export function updateRoleUsers(roleId: number, users: number[]) {
    return httpPatch<PatchRes<"roles/{id}/users/">>(`roles/${roleId}/users/`, { users });
}

// --- audit log -------------------------------------------------------------------------------

export function listAuditLogs({ from = 0, count = 50 }: { from?: number; count?: number }) {
    return httpGet<GetRes<"audit_logs/">>(`audit_logs/?count=${count}&from=${from}`);
}

export function countAuditLogs() {
    return httpGet<GetRes<"audit_logs/count/">>(`audit_logs/count/`);
}
